import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'motion/react';
import { FaArrowRight, FaChevronDown } from 'react-icons/fa';
import PageNavbar from './PageNavbar';
import Footer from './Footer';
import { getRevealProps } from '../motion/scrollMotion';
import { faqCategories } from '../config/faqConfig';
import './ServiceDetailPage.css';
import './KnowledgeBasePage.css';

const FaqItem = ({ q, a }) => {
  const [open, setOpen] = useState(false);
  return (
    <div className={`kb-item ${open ? 'is-open' : ''}`}>
      <button type="button" className="kb-question" onClick={() => setOpen(!open)}>
        <span>{q}</span>
        <FaChevronDown className="kb-chevron" />
      </button>
      {open && <p className="kb-answer">{a}</p>}
    </div>
  );
};

const KnowledgeBasePage = () => (
  <div className="svc-page">
    <PageNavbar />

    <section className="svc-hero">
      <div className="svc-hero-glow" />
      <div className="svc-container">
        <motion.div className="svc-hero-text" style={{ maxWidth: '42rem' }} {...getRevealProps('fadeUp')}>
          <span className="svc-eyebrow">Knowledge Base</span>
          <h1 className="svc-hero-title">Questions We Actually Get Asked.</h1>
          <p className="svc-hero-desc">
            Straight answers to the questions that come up in almost every first call — how
            engagements work, what you get, and how long things take.
          </p>
        </motion.div>
      </div>
    </section>

    <section className="svc-section kb-section">
      <div className="svc-container kb-container">
        {faqCategories.map((cat) => (
          <div className="kb-category" key={cat.name}>
            <h2 className="kb-category-title">{cat.name}</h2>
            <div className="kb-list">
              {cat.items.map((item) => (
                <FaqItem key={item.q} q={item.q} a={item.a} />
              ))}
            </div>
          </div>
        ))}
      </div>
    </section>

    <section className="svc-cta">
      <div className="svc-container">
        <motion.div className="svc-cta-card" {...getRevealProps('scaleUp')}>
          <h2 className="svc-cta-title">Didn't find your answer?</h2>
          <p className="svc-cta-desc">
            Ask us directly — we respond to every inquiry within one business day.
          </p>
          <div className="svc-cta-actions">
            <Link to="/contact" className="svc-btn svc-btn-primary">
              Get In Touch <FaArrowRight />
            </Link>
          </div>
        </motion.div>
      </div>
    </section>

    <Footer />
  </div>
);

export default KnowledgeBasePage;
